<div class="flex flex-col gap-1 text-sm">
  <div class="flex justify-between">
    <span class="text-muted-color">{{ 'invoice.total-without-taxes' | translate }}</span>
    <span>{{ totalWithoutTaxes() | number:'1.2-2' }} €</span>
  </div>

  @for (tax of taxSubtotals(); track tax.name) {
    <div class="flex justify-between">
      <span class="text-muted-color">{{ tax.name }} ({{ tax.rate }}%)</span>
      <span>{{ tax.amount | number:'1.2-2' }} €</span>
    </div>
  }

  <p-divider/>

  <div class="flex justify-between font-semibold">
    <span>{{ 'invoice.total-with-taxes' | translate }}</span>
    <span>{{ totalWithTaxes() | number:'1.2-2' }} €</span>
  </div>

</div>
